import React from "react"
import classNames from "classnames"

export default ({name, className, textAligned, onClick}) => {
  const className_ = classNames("fa", name, className, {
    "align-baseline": textAligned
  })
  const href = `${window.gon.iconsPath}#${name}`
  return (
    <svg className={className_} onClick={onClick}>
      <use href={href}></use>
    </svg>
  )
}
